import { render, staticRenderFns } from "./todolist.vue?vue&type=template&id=48e7b2d3&scoped=true&"
import script from "./todolist.vue?vue&type=script&lang=js&"
export * from "./todolist.vue?vue&type=script&lang=js&"
import style0 from "./todolist.vue?vue&type=style&index=0&id=48e7b2d3&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e7b2d3",
  null
  
)

export default component.exports